// extracted by mini-css-extract-plugin
export var center = "_6r-2";
export var clickableRow = "_6r-5";
export var expandedRow = "_6r-7";
export var hoverable = "_6r-4";
export var left = "_6r-1";
export var right = "_6r-3";
export var row = "_6r-0";
export var selectedRow = "_6r-6";
export var summaryRow = "_6r-8";